// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-icon-button":"sapcnqr-icon-button-9a845b","sapcnqr-icon-button--lg":"sapcnqr-icon-button--lg-be850f","sapcnqr-icon-button--wide":"sapcnqr-icon-button--wide-8d25c9"};